import * as moment from "moment";

export enum KEYPADS_TABLE_COLUMNS {
    CODE = 'Code',
    DESCRIPTION = 'Description',
    ACTIONS = 'Actions',
    RULES = 'Rules',
    EVENTS = 'Events',
}
export const KEYPADS_DEFAULT_START = moment().format('yyyy-MM-DDT00:00');
export const KEYPADS_DEFAULT_END = moment().add(7, 'days').format('yyyy-MM-DDT00:00');

export const KEYPADS_DEFAULT_SORT_COLUMN = KEYPADS_TABLE_COLUMNS.CODE;
export const KEYPADS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const KEYPADS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const KEYPADS_PAGE_DEFAULT_SIZE = 10;
export const KEYPADS_MAX_MEMORY_SIZE = 3000;

export const KEYPADS_TABLE_HEADER = [
    KEYPADS_TABLE_COLUMNS.CODE,
    KEYPADS_TABLE_COLUMNS.DESCRIPTION,
    KEYPADS_TABLE_COLUMNS.ACTIONS,
    KEYPADS_TABLE_COLUMNS.RULES,
    KEYPADS_TABLE_COLUMNS.EVENTS,
];

export const MTMACSTD_MINFWVER_QUICKEASY_KEYPADS = '1.09.000';
export const MTMACUS_MINFWVER_QUICKEASY_KEYPADS = '0.04.002';